import { SummarizerConfig } from '../../types/summarizer';
import YouTubeInputSection from '../../components/summarizer/custom/YouTubeInputSection';

export const youtubeSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'youtube-summarizer',
  title: 'Instant YouTube Video Summarizer with AI',
  outputTitle: 'YouTube Video Summary',
  description: 'Get quick video summaries in any language — no transcript needed.',
  version: '1.0.0',

  // Categorization
  category: 'video',
  tags: ['youtube', 'video', 'social-media', 'education'],

  // Input configuration
  inputs: {
    file: {
      enabled: false, // YouTube doesn't need file upload
    },
    url: {
      enabled: true,
      placeholder: 'Enter YouTube video URL (e.g., https://youtube.com/watch?v=...)',
      validation:
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
      examples: [
        'https://youtu.be/kVWoDpGFrS4?si=73xr0phowIurJ2QW',
        'https://youtu.be/xOO8Wt_i72s?si=cXqopRWqm8HnUx2-',
        'https://youtu.be/_OCb9_F_V6Q?si=wLDkojKuBmkCYrBc',
        'https://youtu.be/Z_DR1_zhmCU?si=kgvTeJC4-ZIk0egw',
      ],
      helpText:
        'Paste any YouTube video URL to get an instant AI summary with key points, transcript, and interactive chat.',
      showExamples: true,
      showHelpText: true,
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: true,
    download: true,
    share: true,
    repurpose: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'youtube',
    timeout: 60000, // 60 seconds for video processing
  },

  // UI customization (Level 1: Basic styling)
  ui: {
    primaryColor: '#ff0000',
    secondaryColor: '#cc0000',
    icon: '📺',
    theme: 'light',
    // Custom loading messages for YouTube content
    loadingMessages: {
      aiGeneration: {
        title: 'AI is analyzing your YouTube video...',
        subtitle: 'Processing video content, extracting insights, and generating a comprehensive summary.',
      },
      translation: {
        title: 'Translating video summary to {language}...',
        subtitle: 'Converting your YouTube video summary to the selected language.',
      },
      streaming: {
        indicator: 'Generating video insights...',
      },
    },
    // Custom input component for YouTube-specific design
    customComponents: {
      input: YouTubeInputSection,
    },
  },

  // Validation rules
  validation: {
    required: true,
    allowedDomains: ['youtube.com', 'youtu.be', 'www.youtube.com'],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
